import type { FaireProductEntity } from "../../entity_types/product";

export const p_uy48enz994: FaireProductEntity = {
  token: "p_uy48enz994",
  type: "product",
  name: "GOLD STAINLESS STEEL INLAID NATURAL STONE RINGS_CWAJE0611",
  brandToken: "b_3eopd3scey",
  brandName: "ACCITY",
  imageUrl:
    "https://cdn.faire.com/fastly/d2a975d4046e8b6892c68f1804e7efc8e579a6776ad658c5dc4f7d14020a5b5f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/90a2dcaf60e980bdc879bcba72a5f9cb1c7e2b5d2d7e6bc9aac688e8c480a12b.jpeg",
    "https://cdn.faire.com/fastly/85832de8778e9a01fab7f781eca05ded6a6ed9bd6a4ceb05f6859032fb98b620.jpeg",
    "https://cdn.faire.com/fastly/77a8c3ea52549857f3d8c45826607be24ed27741e78235aa201b10f4e031ba47.jpeg",
    "https://cdn.faire.com/fastly/79b863a1af8d12f6239f3e3cb508eda0ca654a23d89cdd50e7b21d591e23b8ad.jpeg",
    "https://cdn.faire.com/fastly/84c0a46d87654d115b09e95132268b04d64fdc1b1e3b390e8bff56afd02ea19e.jpeg",
    "https://cdn.faire.com/fastly/1fab25eebfa362b416c99a09e83458e0d87c6c94cb75a862fda69aef16d5c5c9.jpeg",
    "https://cdn.faire.com/fastly/7f97281c173c576a36a6b715affef786e8840f94660d512df458502823f4da35.jpeg",
    "https://cdn.faire.com/fastly/bef7b28adf3567f01304393fe9b93cb6e66d9a3516c98b7825da5561415bb451.jpeg",
    "https://cdn.faire.com/fastly/a601db53ae71efa48a9d3b93a810a7cc15f16bda7e0a2b193e40bb89ec8a4811.jpeg",
    "https://cdn.faire.com/fastly/2862116b6fac1f925d4dfd393b3b9521284cccbd7536a59e89ac2091d5b298e9.jpeg",
    "https://cdn.faire.com/fastly/462536de34e6e49d14308a570c46ff5765359f3079e7bf5ab87fd970041c9bf1.jpeg",
    "https://cdn.faire.com/fastly/c20ad845bc4e16b825156302b3c6d2e484444556343035cf28a1365bf5bd9f7c.jpeg",
    "https://cdn.faire.com/fastly/67dc5e42053bb7504aec33a9560588058fb1aacc6b455498db061a3271dbe759.jpeg",
    "https://cdn.faire.com/fastly/6b6514f0968f6262cf450619749df7d1e308d374242e6aa03e7be3e9ad5e9729.jpeg",
    "https://cdn.faire.com/fastly/6995782053bac0177502dd94b72929baf45635585c35eae760c686f1c9f0902f.jpeg",
    "https://cdn.faire.com/fastly/cf83cafeea4be6955f08b4cde2a85069baea060b162d8bfcd9c7fe434d2b93e9.jpeg",
    "https://cdn.faire.com/fastly/00eaa9425cdf39bce4f937cb8e17f0bcbbc64094c34e3445b11204a3144a19cd.jpeg",
    "https://cdn.faire.com/fastly/e98b908d19010a83909b07533e91760c73b9890a81734e6b975f35f579a8e78b.jpeg",
    "https://cdn.faire.com/fastly/14eea99ff78cea82c88bd8bbd0ddf2415176efc528a7111f1574dcd530d90764.jpeg",
    "https://cdn.faire.com/fastly/1bd6e89a8a5221508070c135bfe2f2fe552bb0f850d5ed9644ddb542944e8d1a.jpeg",
    "https://cdn.faire.com/fastly/44095880fb52c6d5bac3c8e4a2076ee48f9898936426055ac658f07a707be992.jpeg",
    "https://cdn.faire.com/fastly/e6f46a28b65530ac0dcefbdfdb85c5422339f3f75650204f5ffc7cf2a9b5f0a2.jpeg",
    "https://cdn.faire.com/fastly/b8d0de0abf9ff8bded85157ea0b5eb9924ce8476ee0e8921190e6303f3891ab1.jpeg",
    "https://cdn.faire.com/fastly/0b5a903dcfb2322e66256f33116d8fc180912948d382e5ebdda77c77b9f1aa01.jpeg",
    "https://cdn.faire.com/fastly/beea68dbd71ae1d8d8aa4f12fa7dcbf82348d0eac7a5ad58ec610409e95b5df3.jpeg",
    "https://cdn.faire.com/fastly/45a8f078232d8e7ca6c3c60a6de061a641ae4dd692b09fbd31791cc946b10077.jpeg",
    "https://cdn.faire.com/fastly/789ca44b11c2491e5feea2c0b3f7edc73cb62a136074491ba4cd361f0e3715a1.jpeg",
    "https://cdn.faire.com/fastly/598a0d1756c61fe5a6e79a5540b3e1f81cae9d05e8e4ee82a833ceeb8d21dfcd.jpeg",
    "https://cdn.faire.com/fastly/1e42063ea20f3d6a7e3185350dbccf0128ea151c2f96e34e43de18f68a50a6e9.jpeg",
    "https://cdn.faire.com/fastly/ea409ca9951e7eb08d637d8d3fea224ce424288c752217cb2eb5a214765d4f85.jpeg",
    "https://cdn.faire.com/fastly/967aa0bd561068fd8285ea36a0eea2bd6e92fde21da0297046780c4e4ffbc571.jpeg",
    "https://cdn.faire.com/fastly/be566a7e8910f11b7001502f9d803881c786761760d849173900c1cd8cf39e6d.jpeg",
    "https://cdn.faire.com/fastly/d4da97caa497e08aa7d3e31733596fbc0a22ead71211174a97f5b13d7132b384.jpeg",
    "https://cdn.faire.com/fastly/9a043b457f276a566eae3186d440b5671fee559ac17e6671d30cdc36b862d2cf.jpeg",
    "https://cdn.faire.com/fastly/91a39e3e9a4b14bd1c7045a806f2bb8bd20d743b181c86a7f31c18aff4c147c1.jpeg",
    "https://cdn.faire.com/fastly/966b4f0e5e73e23d608f64d32d0d0e614f9df5a4bf5f10e89a164cab2b2abfe0.jpeg",
    "https://cdn.faire.com/fastly/025240eb6b26007b2068e886a535f03e0b0201eb628d210270d8892fa60bd9d4.jpeg",
    "https://cdn.faire.com/fastly/f933bd4cdead10f2b1d5dbf03cd1f2c21e12479cc976c0cb5b72a98f1eaaafef.jpeg",
    "https://cdn.faire.com/fastly/b886c8f0ef5395c1eb79126373290fda98cb459aeaeb680691e7d30eabe94812.jpeg",
  ],
  priceDollars: 8.41,
  description:
    "GOLD STAINLESS STEEL INLAID NATURAL STONE RINGS\nSIZE:OS(3)\n100% STAINLESS STEEL\nNATURAL STONE\nMADE IN CHINA",
  tags: [],
  msrpDollars: 16.82,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:07:58.187Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
